import React from "react";
import Modal from "react-bootstrap/Modal";
import Barcode from "react-barcode";
import { formatNumber } from "utils/currencyFormat";
import ReactToPrint from "react-to-print";

class InMaVachTaiSan1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  renderListMaVach = () => {
    let { data } = this.props;
    if (!data.MaTaiSan) return;
    var lstTaiSan = data.MaTaiSan.split(",");
    var lstTenTaiSan = data.TenTaiSan.split(",");
    let { CustomerName, SoTienVay, Code, MaHopDong } = data;
    return lstTaiSan.map((item, index) => {
      return (
        <div class="col-sm-12" key={"MaVach" + index}>
          <div
            ref={(el) => (this["componentRef" + index] = el)}
            style={{
              display: "flex",
              position: "relative",
              width: 200,
              margin: "auto",
              justifyContent: "center",
            }}
          >
            <table class="table" style={{ border: "0px" }}>
              <tbody>
                <tr>
                  <td style={{ border: "0px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 15,
                      }}
                    >
                      <p
                        style={{
                          display: "block",
                          whiteSpace: "nowrap",
                          fontSize: "14px",
                          mozTransform: "rotate(-90deg)",
                          mozTransformOrigin: "center center",
                          webkitTransform: "rotate(-90deg)",
                          webkitTransformOrigin: "center center",
                          msTransform: "rotate(-90deg)",
                          msTransformOrigin: "center center",
                          color: "#333333",
                          fontWeight: "900",
                          margin: "0px",
                          padding: "0px",
                        }}
                      >
                        {formatNumber(SoTienVay)} VND
                      </p>
                    </div>
                  </td>
                  <td style={{ border: "0px" }}>
                    <div style={{ display: "block" }}>
                      <p
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          margin: "0px 0 5px 0",
                          padding: "0px",
                          color: "#333333",
                          fontWeight: "900",
                        }}
                      >
                        {MaHopDong}
                      </p>
                      <p
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          margin: "0px",
                          padding: "0px",
                        }}
                      >
                        <Barcode
                          width={1}
                          value={item}
                          fontSize={16}
                          height={50}
                        />
                      </p>
                      <p
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          margin: "0px 0 0px 0",
                          padding: "0px",
                          color: "#333333",
                          fontWeight: "900",
                        }}
                      >
                        {CustomerName}
                      </p>
                      <p
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          margin: "0px 0 5px 0",
                          padding: "0px",
                          color: "#333333",
                          fontWeight: "900",
                        }}
                      >
                        {lstTenTaiSan[index]}
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="footer-barcode text-center">
            <ReactToPrint
              trigger={() => {
                // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                // to the root node of the returned component as it will be overwritten.
                return (
                  <button type="button" class="btn btn-new-main btn-checknew">
                    <span class="btn-icon-left">
                      <i class="mdi mdi-printer"></i>
                    </span>
                    In mã
                  </button>
                );
              }}
              content={() => this["componentRef" + index]}
              copyStyles={false}
            />
          </div>
        </div>
      );
    });
  };
  render() {
    let props = this.props;
    let { inmavachtaisan, data, showInMaVachTaiSan } = props;
    let { showModalInMaVach } = inmavachtaisan;
    //showModalInMaVach;
    return (
      <Modal
        {...props}
        size="modal-dialog modal-dialog"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title" id="myModalLabel16">
            <span className="btn-icon-right">
              <img src="/app-assets/images/icon-ma-vach-v21.png" />
            </span>
            In mã vạch
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={props.onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body className="">
          <form className="form tat-toan form-horizontal">
            <div className="form-body">
              <div className="form-body">
                <div class="form-barcode">
                  <div class="row" id="barCodeData">
                    {this.renderListMaVach()}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={props.onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>
            Đóng
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default InMaVachTaiSan1;
